







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GlobalLoader extends Vue {
  @Prop() message: string;
}
